module.exports = __webpack_public_path__ + "img/product.48d722e0.png";